import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const SlideDeckApi = {
    get: (webinarId: string, options?: BaseApiQueryOptions) => apiQueryOptions(['slideDeck', 'get', webinarId], (api) => api.slideDeck.get(webinarId), options),
    delete: (options?: BaseApiMutationOptions<ApiClient['slideDeck']['delete']>) => apiMutationOptions((api) => api.slideDeck.delete, options)
};
